import { render, staticRenderFns } from "./Game1-3.vue?vue&type=template&id=e4083fce&scoped=true&"
import script from "./Game1-3.vue?vue&type=script&lang=js&"
export * from "./Game1-3.vue?vue&type=script&lang=js&"
import style0 from "./Game1-3.vue?vue&type=style&index=0&id=e4083fce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4083fce",
  null
  
)

export default component.exports